import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import logoUniChat from "../../assets/icons/UniChatGreen.png";

const BETA_URL = "https://beta.unichatbot.com.br";

const PONTOS = [
  "É mais rápido e mais fácil de usar",
  "Funciona bem no celular e no computador",
];

const NewVersionModal = ({ open, onClose }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const isDark = theme.palette.mode === "dark";

  const goBeta = () => {
    window.open(BETA_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3.5, overflow: "hidden", boxShadow: theme.shadows[24] },
      }}
    >
      {/* Topo com a cor da marca */}
      <Box
        sx={{
          position: "relative",
          px: 3,
          pt: 4,
          pb: 3.5,
          textAlign: "center",
          color: "#fff",
          overflow: "hidden",
          background: `linear-gradient(135deg, ${primary} 0%, ${alpha(primary, 0.82)} 100%)`,
        }}
      >
        {/* círculos decorativos sutis */}
        <Box sx={{ position: "absolute", top: -55, right: -35, width: 150, height: 150, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.10)" }} />
        <Box sx={{ position: "absolute", bottom: -45, left: -30, width: 110, height: 110, borderRadius: "50%", bgcolor: "rgba(255,255,255,0.07)" }} />

        <IconButton
          onClick={onClose}
          aria-label="Fechar"
          size="small"
          sx={{ position: "absolute", top: 10, right: 10, color: "rgba(255,255,255,0.9)", "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.15)" } }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>

        {/* logo num cartão branco */}
        <Box
          sx={{
            position: "relative",
            width: 76,
            height: 76,
            borderRadius: "22px",
            bgcolor: "#fff",
            boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <Box component="img" src={logoUniChat} alt="UniChat" sx={{ width: 50, height: 50, objectFit: "contain" }} />
        </Box>

        <Typography sx={{ fontWeight: 800, fontSize: 21, position: "relative", letterSpacing: -0.2 }}>
          Chegou o novo UniChat
        </Typography>
        <Typography sx={{ fontSize: 13.5, opacity: 0.92, mt: 0.5, position: "relative" }}>
          Esta versão vai sair do ar em breve
        </Typography>
      </Box>

      {/* Conteúdo */}
      <Box sx={{ px: 3.5, pt: 3, pb: 3.5 }}>
        <Typography sx={{ fontSize: 15, color: "text.primary", lineHeight: 1.65, textAlign: "center" }}>
          Mudamos para um sistema novo, feito pra ser mais simples no dia a dia.
          Em breve esta versão para de funcionar.
        </Typography>

        <Typography sx={{ fontSize: 13.5, color: "text.secondary", textAlign: "center", mt: 2, mb: 1 }}>
          Acesse o novo sistema aqui
        </Typography>

        {/* endereço (clicável) */}
        <Box
          onClick={goBeta}
          sx={{
            py: 1.5,
            px: 2,
            borderRadius: 2,
            textAlign: "center",
            cursor: "pointer",
            bgcolor: alpha(primary, isDark ? 0.18 : 0.09),
            border: `1px solid ${alpha(primary, 0.3)}`,
            color: primary,
            fontWeight: 700,
            fontSize: 16,
            letterSpacing: 0.2,
            transition: "background-color .15s",
            "&:hover": { bgcolor: alpha(primary, isDark ? 0.26 : 0.15) },
          }}
        >
          beta.unichatbot.com.br
        </Box>

        {/* pontos */}
        <Stack spacing={1.1} sx={{ mt: 2.5 }}>
          {PONTOS.map((p) => (
            <Stack key={p} direction="row" alignItems="center" spacing={1}>
              <CheckCircleRoundedIcon sx={{ fontSize: 19, color: primary, flexShrink: 0 }} />
              <Typography sx={{ fontSize: 14, color: "text.primary" }}>{p}</Typography>
            </Stack>
          ))}
        </Stack>

        {/* botões */}
        <Stack spacing={1.25} sx={{ mt: 3 }}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={goBeta}
            startIcon={<OpenInNewRoundedIcon />}
            sx={{
              borderRadius: 2,
              fontWeight: 700,
              py: 1.3,
              textTransform: "none",
              fontSize: 15.5,
              boxShadow: `0 8px 18px ${alpha(primary, 0.35)}`,
              "&:hover": { boxShadow: `0 8px 22px ${alpha(primary, 0.45)}` },
            }}
          >
            Abrir o novo sistema
          </Button>
          <Button
            fullWidth
            variant="text"
            onClick={onClose}
            sx={{ borderRadius: 2, color: "text.secondary", textTransform: "none", fontWeight: 600 }}
          >
            Continuar aqui por enquanto
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

NewVersionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NewVersionModal;
